export const isContainerFirst = (startContainer: Node, startOffset: number, endContainer: Node, endOffset: number) => {
    if (startContainer === endContainer) {
        // Selection within node
        return startOffset <= endOffset;
    } else {
        // Selection over multiple nodes
        const DOCUMENT_POSITION_PRECEDING = 2;
        const compared = startContainer.compareDocumentPosition(endContainer);
        return compared !== DOCUMENT_POSITION_PRECEDING;
    }
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/isContainerFirst.tsx